import * as Sentry from '@sentry/react';

const SENTRY_DNS = import.meta.env.VITE_SENTRY_DSN as string;
const ENV = import.meta.env.MODE; // "development" | "production" | "staging" etc.  (Vite)
const API_BASE_URL = import.meta.env.VITE_API_URL as string;

Sentry.init({
  dsn: SENTRY_DNS,
  environment: ENV,
  enabled: ENV !== 'development',
  debug: ENV === 'development',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: false,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!

  // Control which outbound requests get tracing headers
  tracePropagationTargets: [/localhost/],

  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,

  // Enable logs to be sent to Sentry
  enableLogs: true,
});
